import {Component} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {defaultAvatarStyle, defaultRolesId} from '@features/security/security.constants';
import {UserModel} from '@shared/models/user.model';

@Component({
    standalone: false,
    selector: 'app-manage-role-users',
  templateUrl: './manage-role-users.component.html',
  styleUrl: './manage-role-users.component.scss'
})
export class ManageRoleUsersComponent extends DialogDefinitionEditorBase {
  roleModelId: string;
  platformUsers: any;
  defaultStyle = defaultAvatarStyle;
  defaultRolesId = defaultRolesId;
  currentUserEmail: string;

  constructor(private commandService: CommandService,
              private platformQueryService: PlatformQueryService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  private init() {
    this.roleModelId = this.getRoleModelId();
    this.getPlatformUsers();
  }

  private getRoleModelId() {
    return this.dialogField.options.find(o => o.id === 'RoleModelId').text;
  }


  private getPlatformUsers() {
    const platformUsersByRoleIdQuery = new PlatformQuery();
    platformUsersByRoleIdQuery.name = 'PlatformUsersByRoleIdQuery';
    platformUsersByRoleIdQuery.api = Api.Security;
    platformUsersByRoleIdQuery.fieldValues['RoleModelId'] = this.roleModelId;
    this.platformQueryService.executeQuery(platformUsersByRoleIdQuery).pipe(take(1)).subscribe(response => {
      console.log('PlatformUsersByRoleIdQuery response: ', response);
      this.platformUsers = response.fieldValues['PlatformUsers'];
      this.currentUserEmail = response.fieldValues['CurrentUserEmail'];
    });
  }

  onRemoveUser(user: any) {
    if (!this.dialogField.value) {
      this.dialogField.value = [];
    }
    this.dialogField.value.push(user.id);
    this.dynamicFormControl.setValue(this.dialogField.value);
    this.removeUser(user);
  }

  private removeUser(user: any) {
    const index = this.platformUsers.indexOf(user);
    if (index > -1) {
      this.platformUsers.splice(index, 1);
    }
  }
}
